(() => {
  const hoverQuery = '(min-width: 990px) and (hover: hover) and (pointer: fine)';

  function isHoverDevice() {
    return window.matchMedia(hoverQuery).matches;
  }

  function randomIndex(max) {
    if (window.crypto?.getRandomValues) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % max;
    }

    return Math.floor(Math.random() * max);
  }

  function showRandomFeaturedProducts(menu) {
    const aside = menu.querySelector('.shop-mega-menu__featured[hidden]');
    const container = menu.querySelector('[data-shop-featured-products]');
    const candidates = container ? Array.from(container.querySelectorAll('[data-shop-featured-candidate]')) : [];

    if (!aside || !container) return;

    const selected = [];
    while (candidates.length && selected.length < 2) {
      selected.push(candidates.splice(randomIndex(candidates.length), 1)[0]);
    }

    selected.forEach((candidate) => container.append(candidate.content.cloneNode(true)));
    candidates.forEach((candidate) => candidate.remove());

    if (selected.length) aside.hidden = false;
  }

  function initializeMenu(menu) {
    if (menu.dataset.shopMegaMenuInitialized === 'true') return;

    const details = menu.querySelector(':scope > details.mega-menu');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    menu.dataset.shopMegaMenuInitialized = 'true';
    showRandomFeaturedProducts(menu);

    let closeTimer;

    function clearCloseTimer() {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = undefined;
    }

    function open() {
      if (details.open) return;
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      clearCloseTimer();
      closeTimer = window.setTimeout(() => {
        if (!isHoverDevice() || menu.matches(':hover') || menu.contains(document.activeElement)) return;
        details.removeAttribute('open');
        summary.setAttribute('aria-expanded', 'false');
      }, 150);
    }

    menu.addEventListener('pointerenter', () => {
      if (!isHoverDevice()) return;
      clearCloseTimer();
      open();
    });

    menu.addEventListener('pointerleave', () => {
      if (!isHoverDevice()) return;
      scheduleClose();
    });

    menu.addEventListener('focusin', clearCloseTimer);
    menu.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (isHoverDevice() && !menu.contains(document.activeElement)) scheduleClose();
      });
    });
  }

  function initializeMenus(scope = document) {
    scope.querySelectorAll('header-menu[data-shop-mega-menu-hover]').forEach(initializeMenu);
  }

  function start() {
    initializeMenus();

    if (window.__shopMegaMenuSectionLoadBound) return;

    window.__shopMegaMenuSectionLoadBound = true;
    document.addEventListener('shopify:section:load', (event) => initializeMenus(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
